export default __webpack_public_path__ + "static/DW-Google-8250ebd3ff58a73e7e2f29b27301ef95.svg";